// extracted by mini-css-extract-plugin
export var checkbox = "_6v-0";
export var circle = "_6v-3";
export var horizontalContainer = "_6v-7";
export var sm = "_6v-5";
export var switch0 = "_6v-2";
export var switchDisabled = "_6v-8";
export var switchEnabled = "_6v-1";
export var textSwitchContainer = "_6v-9";
export var textSwitchOption = "_6v-a";
export var textSwitchOptionSelected = "_6v-b";
export var verticalContainer = "_6v-6";
export var xs = "_6v-4";